import React from 'react'
import { useTranslate } from 'react-admin'
import { Box, Typography, Dialog, DialogContent, Button, DialogActions } from '@mui/material'

export const HotelCondition = ({ open, handleClose, hotel }) => {
  const translate = useTranslate()
  function decodeHtml(html) {
    try {
      const txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    } catch (error) {
      return 'Error al mostrar las condiciones'
    }
  }
  if (
    hotel &&
    hotel.remark
  ) {
    const decodedRemark = decodeHtml(hotel.remark); 
    return (
      <Dialog open={open} maxWidth='lg' fullWidth={true}>
        <DialogContent>
          <Box style={{ border: '4px solid #F9F9FD', borderRadius: '10px', padding: 10 }}>
            <Typography variant='h6' component='div' textAlign={'center'}>
              {translate('ra.title.condition')}
            </Typography>
            <div dangerouslySetInnerHTML={{ __html: decodedRemark }} />
          </Box>
          <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
            <Button onClick={handleClose} variant='outlined' color='error'>
              {translate('ra.action.close')}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    )
  }
}
